<mat-card class="mat-card mat-focus-indicator">
    <mat-card-title>
        <h2>System Settings</h2>
    </mat-card-title>

    <mat-card-content>
        <form [formGroup]="systemSettingsForm">
            <div class="row" formGroupName="credits">
                <h3 class="col-12" style="font-weight: 700;">Credits</h3>

                <mat-form-field class="col-3">
                    <input type="number" matInput [ngClass]="{ 'is-invalid': form.credits.get('low_credit_warning').errors }" placeholder="Low Credit Reminder Trigger Level" formControlName="low_credit_warning">
                    <div *ngIf="form.credits.get('low_credit_warning').errors" class="invalid-feedback">
                        <div *ngIf="form.credits.get('low_credit_warning').errors?.required">
                            Low Credit Warning is required.
                        </div>
                    </div>
                    <span matSuffix>
                        <app-popover [popoverContent]="creditLevelPopover" #popover>
                            <mat-icon fontIcon="help"></mat-icon>
                        </app-popover>
                    </span>

                    <ng-template #creditLevelPopover>
                        <mat-card>
                            <mat-card-header>
                                <mat-card-subtitle>Credit Reminder Level</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>Choose the threshold at which the system will remind you to top up your credit balance.</mat-card-content>
                        </mat-card>
                    </ng-template>
                </mat-form-field>

                <div class="col-12" *appCan="'edit_settings'">
                    <button mat-raised-button color="primary" (click)="submitCredits()">Save</button>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
